import {
  Component,
  inject,
  OnDestroy,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { Audit } from 'src/app/model/common/audit';
import {
  DynamicDialogConfig,
  DynamicDialogRef,
} from '@openng/optimus-ui/dynamicdialog';
import { Observable, Subscription } from 'rxjs';
import { LogAndMessageService } from 'src/app/services/log-and-message.service';
import { sortByProperty, SortDirection } from 'src/app/utils/utils';
import { ProgressSpinnerComponent } from '../components/progress-spinner.component';
import { DatePipe } from '@angular/common';

export interface AuditDialogData {
  history: Observable<Audit[]>;
}

@Component({
  selector: 'app-audit-dialog-container',
  templateUrl: './audit-dialog-container.component.html',
  styleUrls: ['./audit-dialog-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ProgressSpinnerComponent, DatePipe, TranslatePipe],
})
export class AuditDialogContainerComponent implements OnDestroy {
  private _translateService = inject(TranslateService);
  private _logAndMessageService = inject(LogAndMessageService);
  private dialogConfig = inject(DynamicDialogConfig<AuditDialogData>);
  private ref = inject(DynamicDialogRef);

  readonly history = signal<Audit[]>([]);
  readonly loading = signal(false);

  private sub?: Subscription;

  constructor() {
    this.loading.set(true);
    this.sub = this.dialogConfig.data.history.subscribe({
      next: (data: Audit[]) => {
        data.sort((a, b) =>
          sortByProperty(a, b, 'updatedAt', SortDirection.DESCENDING)
        );
        this.history.set(data);
        this.loading.set(false);
      },
      error: (error: Error) => {
        this._logAndMessageService.translateToErrorAlert({
          headerKey: 'COMMON.MESSAGES.HEADERS.ERROR',
          bodyKey: 'COMMON.MESSAGES.ERROR.AUDIT_INFO',
        });
        console.error(error);
        this.loading.set(false);
        this.ref.close();
      },
    });
    this._translateService
      .get('COMMON.LABEL.VIEW_AUDIT_INFO')
      .pipe(take(1))
      .subscribe((result) => {
        this.dialogConfig.header = result;
      });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
